import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hostelLogin } from '../../api';
import { FiHome } from 'react-icons/fi';

export default function HostelLogin({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) { setError('Email and password are required'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await hostelLogin(form);
      localStorage.setItem('hostelToken', res.data.token);
      localStorage.setItem('hostelUser', JSON.stringify(res.data.hostel));
      if (onLogin) onLogin(res.data.hostel);
      navigate('/hostel/dashboard');
    } catch (e) {
      setError(e.response?.data?.error || 'Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #091530 0%, #0e1e45 55%, #152c66 100%)',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ width: '72px', height: '72px', borderRadius: '18px', background: 'linear-gradient(135deg, #f5bc1f 0%, #e6a303 55%, #c48a00 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', boxShadow: '0 10px 25px rgba(230,163,3,0.4)' }}>
            <FiHome size={30} color="#091530" />
          </div>
          <h1 style={{ color: '#fff', margin: 0, fontSize: '24px', fontWeight: '700' }}>Hostel Partner Portal</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', margin: '6px 0 0', fontSize: '14px' }}>Hazza Institute of Technology</p>
        </div>

        <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', boxShadow: '0 20px 60px rgba(9,21,48,0.35)' }}>
          <h2 style={{ color: '#1a2340', margin: '0 0 22px', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>Sign In</h2>

          {error && (
            <div className="alert alert-error">{error}</div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '16px' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Email Address</label>
              <input
                type="email" autoComplete="email" autoFocus className="form-control"
                value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
                placeholder="hostel@hit.edu.pk"
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Password</label>
              <input
                type="password" autoComplete="current-password" className="form-control"
                value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                placeholder="••••••••"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: '15px', marginTop: '4px' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
